import { render } from "./commonEditor.vue?vue&type=template&id=7581cba8"
import script from "./commonEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./commonEditor.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/commonControls/commonEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7581cba8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7581cba8', __exports__)) {
    api.reload('7581cba8', __exports__)
  }
  
  module.hot.accept("./commonEditor.vue?vue&type=template&id=7581cba8", () => {
    api.rerender('7581cba8', render)
  })

}


export default __exports__